// src/components/ChartsSection.js
import React from 'react';
// Importe les éléments nécessaires de chart.js et react-chartjs-2
import {
    Chart as ChartJS, // Alias pour l'objet principal ChartJS
    CategoryScale, // Nécessaire pour l'axe des catégories (souvent l'axe X)
    LinearScale, // Nécessaire pour l'axe linéaire (souvent l'axe Y)
    PointElement, // Points sur la ligne
    LineElement, // La ligne elle-même
    ArcElement, // Nécessaire pour les graphiques en secteurs (les arcs)
    Title, // Titre du graphique
    Tooltip, // Infobulle au survol
    Legend, // Légende du graphique
} from 'chart.js';
import { Line, Pie } from 'react-chartjs-2';

// Enregistre les composants Chart.js que tu vas utiliser
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);


// Importe ou définis tes données de graphique ici (pour l'exemple)
// Dans une vraie application, ces données viendraient des props ou de l'état global
const cashFlowChartData = {
    labels: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin'],
    datasets: [
        { label: 'Paiements reçus', data: [1000, 1200, 1500, 1300, 1600, 1800], borderColor: '#18C3BAFF', tension: 0.4, fill: false, pointBackgroundColor: '#18C3BAFF', pointBorderColor: '#fff', pointHoverBackgroundColor: '#fff', pointHoverBorderColor: '#66c2a5', },
        { label: 'Paiements en attente', data: [500, 600, 550, 700, 650, 750], borderColor: '#D3D3D3FF', tension: 0.4, fill: false, pointBackgroundColor: '#D3D3D3FF', pointBorderColor: '#fff', pointHoverBackgroundColor: '#fff', pointHoverBorderColor: '#fc8d62', },
        { label: 'Paiements en retard', data: [100, 50, 80, 120, 90, 110], borderColor: '#0C2A69FF', tension: 0.4, fill: false, pointBackgroundColor: '#0C2A69FF', pointBorderColor: '#fff', pointHoverBackgroundColor: '#fff', pointHoverBorderColor: '#8da0cb', },
    ],
};

const cashFlowChartOptions = {
    responsive: true,
    plugins: {
        legend: { display: false }, // On gère la légende manuellement
        title: { display: false }, // On gère le titre manuellement
        tooltip: {
            callbacks: {
                label: function(context) {
                    let label = context.dataset.label || '';
                    if (label) {
                        label += ': ';
                    }
                    if (context.raw !== null) {
                        label += new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(context.raw);
                    }
                    return label;
                }
            }
        }
    },
    scales: {
        y: {
            ticks: {
                callback: function(value, index, values) {
                    return value + ' €';
                }
            }
        }
    },
    maintainAspectRatio: false, // Permet de mieux contrôler la taille via CSS si responsive est true
};


const salesDistributionData = {
    labels: ['Client A', 'Client B', 'Client C', 'Autres'],
    datasets: [
        {
            data: [30000, 20000, 15000, 35000],
            backgroundColor: [
                '#0c2a69', '#18c3ba', '#80ffc7' // Quelques couleurs supplémentaires
            ],
            borderColor: '#fff',
            borderWidth: 2,
        },
    ],
};

const salesDistributionOptions = {
    responsive: true,
    plugins: {
        legend: { position: 'right' },
        title: { display: false }, // On gère le titre manuellement
        tooltip: {
            callbacks: {
                label: function(context) {
                    const label = context.label || '';
                    const value = context.raw || 0;
                    const total = context.chart.getDatasetMeta(0).total;
                    const percentage = parseFloat(((value / total) * 100).toFixed(1));
                    return `${label}: ${new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value)} (${percentage}%)`;
                }
            }
        }
    },
    maintainAspectRatio: false,
};


function ChartsSection({ initialCashFlowData, initialSalesDistributionData }) { // Renommé les props pour éviter la confusion avec les constantes locales
    // Dans une vraie application, tu utiliserais initialCashFlowData et initialSalesDistributionData
    // passés depuis le composant parent (SyntheseFinancierePage)

    return (
        <div className="charts-section">
            <div className="chart-container">
                <h3>Flux de paiements</h3>
                {/* Utilise le composant Line de react-chartjs-2 */}
                <div className="chart-canvas-container"> {/* Ajout d'un conteneur pour mieux gérer la taille */}
                    <Line data={cashFlowChartData} options={cashFlowChartOptions} />
                </div>

                {/* Légende manuelle, car on l'a désactivée dans les options du graphique */}
                <div className="chart-legend">
                    <div className="legend-item received">Paiements reçus</div>
                    <div className="legend-item pending">Paiements en attente</div>
                    <div className="legend-item overdue">   Paiements en retard</div>
                </div>
            </div>

            <div className="chart-container">
                <h3>% du chiffre d'affaires par client</h3>
                <div className="chart-options">Afficher les 5 plus gros clients</div>
                {/* Utilise le composant Pie de react-chartjs-2 */}
                <div className="chart-canvas-container pie"> {/* Ajout d'un conteneur pour mieux gérer la taille */}
                    {/* Pour afficher deux pie charts côte à côte, tu peux utiliser deux composants Pie */}
                    {/* Ici, j'en mets un seul pour l'exemple, montrant la répartition globale */}
                    <Pie data={salesDistributionData} options={salesDistributionOptions} />
                </div>
                {/* Si tu veux afficher les 5 plus gros clients sous forme de deux graphiques comme sur le design,
            tu devras potentiellement préparer les données différemment (par exemple, un dataset
            pour chaque pie chart) et utiliser deux composants <Pie /> ici.
        */}
            </div>
        </div>
    );
}

export default ChartsSection;